import { ContainerModule } from "inversify";
import {
  IObterAgendamentosGateway,
  obterAgendamentosGatewayDI
} from "../ports/ObterAgendamentosGateway";
import { ObterAgendamentosGatewayAdapter } from "../adapters/ObterAgendamentosGatewayAdapter";
import {
  IObterAgendamentosUseCase,
  obterAgendamentosUseCaseDI
} from "../ports/ObterAgendamentosUseCase";
import { ObterAgendamentosUseCaseAdapter } from "../adapters/ObterAgendamentosUseCaseAdapter";
import {
  criarAgendamentoUseCaseDI,
  ICriarAgendamentoUseCase
} from "../ports/CriarAgendamentoUseCase";
import { CriarAgendamentoUseCaseAdapter } from "../adapters/CriarAgendamentoUseCaseAdapter";
import {
  criarAgendamentosGatewayDI,
  ICriarAgendamentoGateway
} from "../ports/CriarAgendamentoGateway";
import { CriarAgendamentoGatewayAdapter } from "../adapters/CriarAgendamentoGatewayAdapter";

export const agendamentosContainer = new ContainerModule((bind) => {
  bind<IObterAgendamentosGateway>(obterAgendamentosGatewayDI).to(
    ObterAgendamentosGatewayAdapter
  );
  bind<IObterAgendamentosUseCase>(obterAgendamentosUseCaseDI).to(
    ObterAgendamentosUseCaseAdapter
  );
  bind<ICriarAgendamentoGateway>(criarAgendamentosGatewayDI).to(
    CriarAgendamentoGatewayAdapter
  );
  bind<ICriarAgendamentoUseCase>(criarAgendamentoUseCaseDI).to(
    CriarAgendamentoUseCaseAdapter
  );
});
